/* eslint formatjs/no-literal-string-in-jsx: "error" */

import React from "react"
import { Container, H1, Text, Modal, Stack } from "@carrotfertility/carotene"
import { ArrowLink } from "../../../../components/views/atoms/links/ArrowLink"
import { Spacer } from "../../../../components/views/atoms/Atoms"
import { FormattedMessage, MessageDescriptor } from "react-intl"
import { Benefit } from "pages/provider-finder/types/Benefit"

export type tierForModalProps = {
  tierDisplayName?: MessageDescriptor
  backgroundColor?: string
  color?: string
  iconColor?: string
  modalTitle?: MessageDescriptor
  modalDescription?: MessageDescriptor
}

interface TierInfoModalProps {
  open: boolean
  onClose: () => void
  tierForModal?: tierForModalProps
  benefit: Benefit
}

export const TierInfoModal = ({ open, onClose, tierForModal, benefit }: TierInfoModalProps): JSX.Element => {
  const hasCustomCoverageText = !!benefit.customizations.memberCustomCoverageExplanationMarkdown

  return (
    <Modal open={open} onClose={onClose} showClose>
      <Stack spacing="small" stack="large">
        <Container padding=" 0 48px 14px 48px">
          <H1 padding="22px 0 4px 0">
            <FormattedMessage {...tierForModal?.modalTitle} />
          </H1>
          <Text color="black80">
            <FormattedMessage {...tierForModal?.modalDescription} />
          </Text>
          {hasCustomCoverageText ? (
            <>
              <Spacer height={3} />
              <ArrowLink to="/your-benefit-guide/coverage/employer-specific-information">
                <FormattedMessage defaultMessage="Learn more" />
              </ArrowLink>
            </>
          ) : null}
        </Container>
      </Stack>
    </Modal>
  )
}
